<template>
  <button
    :disabled="disabled"
    class="flex font-medium items-center justify-center gap-[8px] leading-7 w-fit h-fit py-1.5 px-4 text-base rounded hover:shadow-button disabled:bg-grays-400 disabled:shadow-none disabled:text-grays-600"
    :class="[
      colorClasses,
      container ? 'w-[300px] flex-none' : '',
      small ? 'py-0.5 px-4' : '',
    ]"
  >
    <slot></slot>
  </button>
</template>

<script>
const colorMap = {
  primary:
    "text-primary-400 bg-primary-700 hover:bg-primary-800 focus:bg-primary-900 focus:shadow-none active:bg-primary-900 active:shadow-none",
  secondary:
    "text-secondary-600 bg-secondary-400 hover:bg-secondary-300 focus:bg-secondary-200 focus:shadow-none active:bg-secondary-200 active:shadow-none",
  complementary:
    "text-complementary-900 bg-complementary-700 hover:bg-complementary-800 focus:bg-complementary-900 focus:shadow-none active:bg-complementary-900 active:shadow-none",
  error:
    "text-white bg-error hover:opacity-90 focus:opacity-80 focus:shadow-none active:opacity-80 active:shadow-none",
  success:
    "text-white bg-success hover:opacity-90 focus:opacity-80 focus:shadow-none active:opacity-80 active:shadow-none",
};

export default {
  name: "button-primary",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
      validator: (v) => Object.keys(colorMap).includes(v),
    },
  },
  computed: {
    colorClasses() {
      return colorMap[this.color] ?? colorMap.primary;
    },
  },
};
</script>

<style>
</style>